import { reactive } from 'vue'
import { useI18n } from 'vue-i18n'
import { useUser } from '@/app/Checkout/composables/useUser'
import { useCart } from '@/app/Checkout/composables/useCart'
import { useAuth } from '@/app/Checkout/composables/useAuth'

export function useAddressValidation() {
  const { t } = useI18n()
  const { user } = useUser()
  const { cart } = useCart()
  const errors = reactive({})
  const { isLoggedIn } = useAuth()
  const emptyAddress = () => ({
    firstname: '',
    lastname: '',
    zip: '',
    city: '',
    address: '',
    company: '',
    gender: '',
    email: '',
    postnumber: null,
    house_number: '',
    is_default: false,
    packstation: null,
    address_details: '',
    station_deliver: 'address',
    country: isLoggedIn.value ? user.value?.default_country.toUpperCase() : cart.value?.country,
    phone_country_code: isLoggedIn.value ? user.value?.default_country.toUpperCase() : cart.value?.country,
  })

  /** Logged-in checkout "add address": prefill profile gender/name/lastname + country. */
  const emptyLoggedInNewAddress = () => {
    const base = emptyAddress()
    const rawGender = user.value?.gender
    const gender =
      rawGender === undefined || rawGender === null || rawGender === ''
        ? ''
        : Number(rawGender)

    const defaultCountry = user.value?.default_country?.toUpperCase() || ''

    return {
      ...base,
      // Country is required by validation, so we keep it prefilled for logged-in users.
      country: defaultCountry,
      phone_country_code: defaultCountry,
      phone: '',
      gender,
      firstname: user.value?.firstname ?? '',
      lastname: user.value?.lastname ?? '',
    }
  }

  function validate(address, allowStation = true) {
    clearErrors()

    if (!address.gender)
      errors.gender = t('my_account.register.title_is_required')

    if (!address.firstname)
      errors.firstname = t('my_account.register.first_name_is_required')

    if (!address.lastname)
      errors.lastname = t('my_account.register.last_name_is_required')

    if (!address.city)
      errors.city = t('app.address.city_is_required')

    if (!address.zip)
      errors.zip = t('app.address.zip_is_required')

    if (!isLoggedIn.value && !address.email)
      errors.email = t('my_account.register.email_is_required')

    // Handle station logic only if allowed
    if (allowStation && address.station_deliver === 'station') {
      if (!address.packstation)
        errors.packstation = t('app.address.pack_number_is_required')

      if (!address.postnumber)
        errors.postnumber = t('app.address.post_number_is_required')
    } else {
      if (!address.house_number)
        errors.house_number = t('app.address.house_number_is_required')

      if (!address.address)
        errors.address = t('app.address.street_is_required')

      if (!address.country)
        errors.country = t('app.address.country_is_required')
    }

    return Object.keys(errors).length === 0
  }

  function clearErrors() {
    Object.keys(errors).forEach(key => delete errors[key])
  }

  function clearField(field) {
    if (errors[field]) {
      delete errors[field]
    }
  }

  return {
    errors,
    validate,
    clearField,
    emptyAddress,
    emptyLoggedInNewAddress,
  }
}
